import { z } from 'zod';
import { ChecklistItem, OperationPriority, ProofType } from './operations.js';
import { HouseholdId, IsoDatetime, RoutineId, UserId } from './primitives.js';

export const Routine = z.object({
  id: RoutineId,
  household_id: HouseholdId,
  title: z.string().min(1).max(200),
  description: z.string().max(2000).nullable(),
  assignee_user_id: UserId.nullable(),
  priority: OperationPriority,
  proof_required: z.boolean(),
  proof_types: z.array(ProofType),
  checklist: z.array(ChecklistItem),
  schedule_rrule: z.string().min(1).max(500),
  schedule_tz: z.string(),
  active: z.boolean(),
  last_emitted_at: IsoDatetime.nullable(),
  next_emit_at: IsoDatetime.nullable(),
  created_by_user_id: UserId,
  created_at: IsoDatetime,
  updated_at: IsoDatetime,
});
export type Routine = z.infer<typeof Routine>;

export const CreateRoutineRequest = z.object({
  title: z.string().min(1).max(200),
  description: z.string().max(2000).optional(),
  assignee_user_id: UserId,
  priority: OperationPriority.default('normal'),
  proof_required: z.boolean().default(false),
  proof_types: z.array(ProofType).default([]),
  checklist: z.array(z.object({ label: z.string().min(1).max(200) })).default([]),
  schedule_rrule: z.string().min(1).max(500),
  schedule_tz: z.string(),
  // How long after each occurrence this counts as late. Per routine because
  // "water the plants" is fine any time today and "collect the dry cleaning
  // before they close" is not. One day by default.
  grace_minutes: z.number().int().min(0).max(20160).default(1440),
});
